import { FC, useRef } from "react";

import { useTranslation } from "next-i18next";

import Select from "@components/Select";

import loadAddresses from "./services/loadAddresses";
import type { TAddressBookEntry } from "./types";
import mapAddressItemsToSelectOptions from "./utils/mapAddressItemsToSelectOptions";

type TAddressBookSearchInputProps = {
  id: string;
  type: "locker" | "address";
  countryCode: string;
  onAddressSelect: (address: TAddressBookEntry | undefined) => void;
  onError?: (message?: string) => void;
};

const AddressBookSearchInput: FC<TAddressBookSearchInputProps> = ({
  id,
  type,
  countryCode,
  onAddressSelect,
  onError,
}) => {
  const { t } = useTranslation();

  const optionsAddressesRef = useRef<TAddressBookEntry[]>([]);

  const handleLoadAddresses = async (query: any) => {
    const addresses = await loadAddresses({ search: query, countryCode, type, onError });
    optionsAddressesRef.current = addresses;
    return mapAddressItemsToSelectOptions(addresses, type);
  };

  const handleAddressChanged = (addressId: any) => {
    const selectedAddress = (optionsAddressesRef.current || []).find(
      ({ id: optionAddressId }) => addressId === optionAddressId
    );
    onAddressSelect(selectedAddress);
  };

  return (
    <Select
      isFormik={false}
      label={t("address_book_search-choose_from_address_book")}
      id={id}
      loadOptions={handleLoadAddresses}
      onChange={handleAddressChanged}
      mode="asyncOption"
      shouldClearOnSelect
    />
  );
};
export default AddressBookSearchInput;
